module.exports = __webpack_public_path__ + "096d6c45a3e2546900264710dd89fd51.svg";